import * as React from "react";
import { connect, Dispatch } from "react-redux";
import { initialize } from "redux-form";
import { RootState } from "../../../redux/index";
import API from "../../../vendor/api";

// import Tab from "../../../components/Tab";
import SecondaryHeader from "../../../components/Header/Secondary";
// import Avatar from "../../../components/Avatar";
// import ChatList from "../../ChatList";
// import ContactList from "../../ContactList";

import EditMyProfileForm, { Fields } from "../../../components/Forms/EditMyProfile";

import { selectSidebarView } from "../../../redux/modules/ui/ui";
import { editProfile } from "../../../redux/modules/appAuth/appAuth";

const s = require("./sidebar.scss");

interface ISidebarProps {
    user: API.User;
    activeView: string;
    dispatch?: Dispatch<any>;
};

interface ISidebarState {};

class Sidebar extends React.Component<ISidebarProps, ISidebarState> {
    onGoBack() {
        this.props.dispatch(selectSidebarView("chatList"));
    }

    onSubmit(fields: Fields) {
        const user = this.props.user;
        this.props.dispatch(editProfile(fields.name, fields.email, user.gender));
    }

    componentDidMount() {
        const user = this.props.user;
        this.props.dispatch(initialize("EditMyProfileForm", {
            name: user.name,
            email: user.email
        }));
    }

    componentWillReceiveProps(nextProps: ISidebarProps) {
        const user = nextProps.user;
        this.props.dispatch(initialize("EditMyProfileForm", {
            name: user.name,
            email: user.email
        }));
    }

    render(): JSX.Element {
        return (
            <div className={s.sidebar}>
                <div className={s.header}>
                    <SecondaryHeader
                        title="Editar perfil"
                        onGoBack={this.onGoBack.bind(this)}
                    />
                </div>

                <EditMyProfileForm
                    onSubmit={this.onSubmit.bind(this)}
                />
            </div>
        );
    }
}

export default connect((state: RootState) => ({
    user: state.auth.user,
    activeView: state.ui.sidebar.view
}))(Sidebar);



// WEBPACK FOOTER //
// ./src/containers/Sidebar/EditProfile/index.tsx